import React from "react";
import "./Occasions.css";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { useProducts } from "../../context/ProductContext";

const Occasions = () => {
	const { products, categories, loading } = useProducts();
	const [ref, inView] = useInView({
		triggerOnce: true,
		threshold: 0.1,
	});

	const featuredProducts = categories
		.slice(0, 3)
		.map((cat) => {
			const catProducts = products.filter((p) => p.category === cat.id);
			return catProducts[0] || null;
		})
		.filter(Boolean);

	return (
		<section className="occasions section-padding" ref={ref}>
			<div className="container">
				<motion.div
					className="featured-header"
					initial={{ opacity: 0, y: 30 }}
					animate={inView ? { opacity: 1, y: 0 } : {}}
					transition={{ duration: 0.7 }}
				>
					<p className="featured-label">Curated for You</p>
					<h2 className="featured-heading">Featured Picks</h2>
					<p className="featured-subtitle">
						A hand-selected edit of our most loved pieces — from statement bouquets to thoughtful gifts.
					</p>
				</motion.div>

				{!loading && featuredProducts.length > 0 && (
					<motion.div
						className="featured-products-grid"
						initial={{ opacity: 0, y: 40 }}
						animate={inView ? { opacity: 1, y: 0 } : {}}
						transition={{ duration: 0.8, delay: 0.1 }}
					>
						{featuredProducts.map((item) => (
							<Link to={`/product/${item.slug}`} key={item.id} className="featured-product-card">
								<div className="featured-product-image">
									<img src={item.images[0]} alt={item.title} />
								</div>
								<div className="featured-product-info">
									<span className="featured-product-category">{item.categoryLabel}</span>
									<h3 className="featured-product-title">{item.title}</h3>
								</div>
							</Link>
						))}
					</motion.div>
				)}

				<div className="section-divider" />

				{!loading && categories.map((cat, index) => {
					const catProducts = products.filter((p) => p.category === cat.id);
					const heroImage = catProducts[0]?.images?.[0];
					if (!heroImage) return null;

					return (
						<motion.div
							key={cat.id}
							className={`occasion-block${index % 2 !== 0 ? " occasion-block-reversed" : ""}`}
							initial={{ opacity: 0, y: 40 }}
							animate={inView ? { opacity: 1, y: 0 } : {}}
							transition={{ duration: 0.8, delay: 0.2 * (index + 1) }}
						>
							<div className="occasion-text">
								<h2 className="occasion-label">{cat.label}</h2>
								<p className="occasion-description">
									Explore our curated {cat.label.toLowerCase()} collection, crafted for life's most beautiful moments.
								</p>
								<Link to={`/collections/${cat.slug}`} className="occasion-cta">
									Shop {cat.label}
								</Link>
							</div>
							<div className="occasion-image">
								<img src={heroImage} alt={cat.label} />
							</div>
						</motion.div>
					);
				})}
			</div>
		</section>
	);
};

export default Occasions;
